// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"221":"1e7671e4","307":"9e11eba1","660":"6a7a94f0","773":"5b76b143","971":"61e00f05"}[chunkId] + ".chunk.css";
};